export default function getDefaultFileProvider(fileProvidersViewState) {
    if (fileProvidersViewState.length !== 0) {
        return fileProvidersViewState[0];
    }
    return null;
}
//# sourceMappingURL=getDefaultFileProvider.js.map